import { ListViewSchema } from "./Common";

import styles from "./BoardListViewHeader.module.css";

interface ListViewHeaderProps {
    cols: number;
    schema: ListViewSchema[];
}

/**
 * @author khy
 * @date 2022-08-31 16:33
 * @remark 테이블 헤더
 * @param cols (required)
 * 테이블 컬럼의 갯수
 * @param schema (required)
 * 컴포넌트를 만들기 위한 schema
 * @returns ListViewHeader JSX.Element
 */

function ListViewHeader(props: ListViewHeaderProps) {
    /**
     * renderItem 들의 Col width 을 설정해주기 위한 함수
     * @param widthRatios ex) [ 1.5, 4, 1, 3, 0.5 ] col width
     * @return ex) [ 15, 40, 10, 30, 5 ] // widthRatios 를 총합 100% 이내로 각각 비율에 맞게 나눠 줌
     */

    const resizeColumnWidth = (widthRatios: number[]) => {
        const divide = widthRatios.reduce((prev, current) => prev + current, 0);
        const per = 100 / divide;
        const widths = widthRatios.map((e) => (e * per).toFixed(2));

        return widths;
    };

    const widthRatios = props.schema ? props.schema.map((e) => (e.widthRatio as number) ?? 1) : [1]; // columns 에 widthRatio 가 없으면 기본 비율을 1로 배정함
    const widths = resizeColumnWidth(widthRatios);

    return (
        <div className={`${styles.row} ${styles.header}`}>
            {Array.from(Array(props.cols)).map((empty, index) => {
                const column = props.schema[index];
                const width = widths[index] !== undefined ? `${widths[index]}%` : undefined;

                const columnStyle = column?.style ? { width, ...column.style } : { width };

                if (column !== undefined) {
                    return (
                        <div className={`${styles.col} ${styles.headerCol}`} style={columnStyle} key={`col[${index}]`}>
                            {column.title}
                        </div>
                    );
                } else {
                    return <div key={`col[${index}]`}></div>;
                }
            })}
        </div>
    );
}

export default ListViewHeader;
